import React, { Component } from "react";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Add from "@material-ui/icons/Add";
import Button from "../../components/CustomButtons/Button.jsx";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import TextField from "@material-ui/core/TextField";
import { useSpring, animated } from "react-spring";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import FavoriteBorderOutlined from "@material-ui/icons/FavoriteBorderOutlined";
import ChatBubbleOutline from "@material-ui/icons/ChatBubbleOutline";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Container from "@material-ui/core/Container";
import logo from "../../images/dut.png";
import dutylogo from "../../images/dutylogo.png";
import addphoto from "../../images/addphoto.png";
import dutyConnect from "../../images/DutyConnect.jpeg";
import check from "../../images/check.png";
import dutyPlanner from "../../images/DutyPlanner.jpeg";
import dutyControl from "../../images/DutyControl.jpeg";
import Grid from "@material-ui/core/Grid";
import "./news.css";
import { Link } from "react-router-dom";
import errorImg from "../../images/error.png";
export default class News extends Component {
  constructor(props) {
    super(props);
    this.nov = {
      novedades: [],
      obj: {}
    };
    this.state = {
      open1: false,
      handleClose2: true,
      tit: "",
      sub: "",
      text: "",
      img: "",
      imagePreviewUrl: addphoto,
      modals: false,
      modalErrorStatus: false
    };
  }
  componentDidMount() {
    console.log(window.innerWidth > 600);
  }
  _pickImage = () => {
    return (
      <div className="picture-container">
        <div className="picnov picture">
          <img
            style={{ height: "100%" }}
            src={this.state.imagePreviewUrl}
            className="picture-src"
            alt="..."
          />
          <input type="file" onChange={e => this.handleImageChange(e)} />
        </div>
      </div>
    );
  };
  handleImageChange = e => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });
    };
    reader.readAsDataURL(file);
  };
  modalError = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modalErrorStatus}
        open={this.state.modalErrorStatus}
        onClose={() => {
          this.setState({ modalErrorStatus: false });
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          style={{
            margin: "auto",
            marginTop: 100,
            width: window.innerWidth < 600 ? "70%" : "50%",
            height: 350,
            alignItems: "center"
          }}
        >
          <CardContent className="textCardNov2"></CardContent>
          <CardMedia
            style={{
              height: "50%",
              width: "50%",
              margin: "auto",
              backgroundSize: "contain"
            }}
            className="textCardNov2"
            image={errorImg}
            title="error"
          ></CardMedia>
          <CardContent
            className="textCardNov2"
            style={{
              textAlign: "center !important",
              alignContent: "center !important"
            }}
          >
            <Typography
              className="titCard"
              style={{ textAlign: "center" }}
              gutterBottom
              variant="h5"
              component="h2"
            >
              Error
            </Typography>
            <Typography
              variant="txtCardNov"
              color="textSecondary"
              component="p"
            >
              Debes completar todos los campos.
            </Typography>
            <Button
              className="btn2"
              onClick={() => {
                this.setState({ modalErrorStatus: false });
              }}
            >
              <Typography className="btnNewNov2">ACEPTAR</Typography>
            </Button>
          </CardContent>
        </Card>
        {/* </Fade> */}
      </Modal>
    );
  };
  _listaNueva = () => {
    if (this.nov.novedades.length > 0) {
      // for (let i in this.nov.novedades) {
      return (
        <div>
          {this.nov.novedades.map((item, i) => {
            return (
              <div
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  display: "flex"
                }}
              >
                <Grid
                  item
                  xs={2}
                  md={1}
                  style={{ justifyContent: "center", display: "flex" }}
                >
                  <img src={dutylogo} className="logonov" alt="logo" />
                </Grid>
                <Grid
                  item
                  xs={8}
                  md={6}
                  style={{ justifyContent: "flex-start" }}
                >
                  <Card style={{ width: "100%", marginBottom: 15 }}>
                    <CardMedia
                      className={useStyles.media}
                      image={this.nov.novedades[i].imagen}
                      title="Novedad"
                    >
                      <img
                        src={this.nov.novedades[i].imagen}
                        style={{ width: "100%" }}
                      />
                    </CardMedia>
                    <CardContent className="textCardNov">
                      <Typography
                        className="titCard"
                        gutterBottom
                        variant="h5"
                        component="h2"
                      >
                        {this.nov.novedades[i].titulo}
                      </Typography>
                      <Typography
                        className="subCardNov"
                        variant="body2"
                        color="textSecondary"
                        component="h4"
                      >
                        {this.nov.novedades[i].subtitulo}
                      </Typography>
                      <Typography
                        variant="txtCardNov"
                        color="textSecondary"
                        component="p"
                      >
                        {this.nov.novedades[i].texto}
                      </Typography>
                    </CardContent>
                    <CardActions className="buttomCard">
                      <div className="iconsButtomCard" style={{ width: "60%" }}>
                        <IconButton
                          aria-label="add to favorites"
                          style={{ padding: 0 }}
                        >
                          <FavoriteBorderOutlined className="iconFav" />
                        </IconButton>
                        <Typography
                          variant="txtCardNov"
                          color="textSecondary"
                          component="p"
                          style={{ marginRight: 5, fontWeight: "300" }}
                        >
                          Me gusta
                        </Typography>
                        <IconButton aria-label="share" style={{ padding: 0 }}>
                          <ChatBubbleOutline className="iconFav" />
                        </IconButton>
                        <Typography
                          variant="txtCardNov"
                          color="textSecondary"
                          component="p"
                          style={{ marginRight: 5, fontWeight: "300" }}
                        >
                          Comentar
                        </Typography>
                      </div>
                      <div className="divDerec" style={{ width: "30%" }}>
                        <Typography
                          variant="txtCardNov"
                          color="textSecondary"
                          component="p"
                          style={{ fontWeight: "300" }}
                        >
                          1 Me gusta
                        </Typography>
                      </div>
                    </CardActions>

                    <CardContent
                      style={{
                        justifyContent: "flex-start",
                        flexDirection: "row",
                        display: "flex",
                        paddingTop: 0,
                        paddingBottom: 5
                      }}
                    >
                      <div>
                        <img src={dutylogo} className="personNov" alt="logo" />
                      </div>
                      <div style={{ width: "100%" }}>
                        <TextField
                          id="standard-full-width"
                          style={{
                            marginTop: 8,
                            marginBottom: 8,
                            width: "100%",
                            fontSize: 14
                          }}
                          placeholder="Comentar"
                          fullWidth
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              </div>
            );
          })}
        </div>
      );
      // }
    }
  };
  _listaNov = () => {
    return (
      <Grid
        container
        spacing={1}
        style={{ width: "100%", justifyContent: "center", display: "contents" }}
      >
        {this._listaNueva()}
        <div
          style={{
            flexDirection: "row",
            justifyContent: "center",
            display: "flex"
          }}
        >
          <Grid
            item
            xs={2}
            md={1}
            style={{ justifyContent: "center", display: "flex" }}
          >
            <img src={dutylogo} className="logonov" alt="logo" />
          </Grid>
          <Grid item xs={8} md={6} style={{ justifyContent: "flex-start" }}>
            <Card style={{ width: "100%", marginBottom: 15 }}>
              <CardMedia
                className={useStyles.media}
                image={dutyConnect}
                title="Novedad"
              >
                <img src={dutyConnect} style={{ width: "100%" }} />
              </CardMedia>
              <CardContent className="textCardNov">
                <Typography
                  className="titCard"
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  Comunicar a su organización de manera sencilla y moderna
                </Typography>
                <Typography
                  className="subCardNov"
                  variant="body2"
                  color="textSecondary"
                  component="h4"
                >
                  Logra que todos conozcan las ultimas novedades
                </Typography>
                <Typography
                  variant="txtCardNov"
                  color="textSecondary"
                  component="p"
                >
                  Duty es la forma más rápida de generar formularios, realizar
                  auditorias y compartir toda la información relevada, desde
                  sitios web y aplicaciones móviles hasta la posiblidad de
                  generar tareas compartidas, y más. Conoce mas en:
                  www.dutygestion.com
                </Typography>
              </CardContent>
              <CardActions className="buttomCard">
                <div className="iconsButtomCard" style={{ width: "60%" }}>
                  <IconButton
                    aria-label="add to favorites"
                    style={{ padding: 0 }}
                  >
                    <FavoriteBorderOutlined className="iconFav" />
                  </IconButton>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ marginRight: 5, fontWeight: "300" }}
                  >
                    Me gusta
                  </Typography>
                  <IconButton aria-label="share" style={{ padding: 0 }}>
                    <ChatBubbleOutline className="iconFav" />
                  </IconButton>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ marginRight: 5, fontWeight: "300" }}
                  >
                    Comentar
                  </Typography>
                </div>
                <div className="divDerec" style={{ width: "30%" }}>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ fontWeight: "300" }}
                  >
                    30 Me gusta
                  </Typography>
                </div>
              </CardActions>
              <CardContent
                style={{
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  display: "flex",
                  paddingTop: 0,
                  paddingBottom: 5
                }}
              >
                <div>
                  <img src={dutylogo} className="personNov" alt="logo" />
                </div>
                <div style={{ width: "100%" }}>
                  <TextField
                    id="standard-full-width"
                    style={{
                      marginTop: 8,
                      marginBottom: 8,
                      width: "100%",
                      fontSize: 14
                    }}
                    placeholder="Comentar"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </div>

        <div
          style={{
            flexDirection: "row",
            justifyContent: "center",
            display: "flex"
          }}
        >
          <Grid
            item
            xs={2}
            md={1}
            style={{ justifyContent: "center", display: "flex" }}
          >
            <img src={dutylogo} className="logonov" alt="logo" />
          </Grid>
          <Grid item xs={8} md={6} style={{ justifyContent: "flex-start" }}>
            <Card style={{ width: "100%", marginBottom: 15 }}>
              <CardMedia
                className={useStyles.media}
                image={dutyPlanner}
                title="Novedad"
              >
                <img src={dutyPlanner} style={{ width: "100%" }} />
              </CardMedia>
              <CardContent className="textCardNov">
                <Typography
                  className="titCard"
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  Gestión de procesos
                </Typography>
                <Typography
                  className="subCardNov"
                  variant="body2"
                  color="textSecondary"
                  component="h4"
                >
                  Hacemos que la gestión de tareas sea increíblemente sencilla
                </Typography>
                <Typography
                  variant="txtCardNov"
                  color="textSecondary"
                  component="p"
                >
                  Delegar y supervisar el flujo de tareas de su organización
                  nunca fue tan sencillo. Cree y asigne tareas y proyectos, en
                  cualquier momento y lugar, y reciba notificaciones sobre su
                  avance. Exprese su flujo de procesos y administre proyectos
                  con nuestra arquitectura de metodologías ágiles. Ponemos a su
                  servicio todo nuestro conocimiento en ciclos de alta
                  productividad para que acelere su crecimiento. Conoce más en:
                  www.dutygestion.com
                </Typography>
              </CardContent>
              <CardActions className="buttomCard">
                <div className="iconsButtomCard" style={{ width: "60%" }}>
                  <IconButton
                    aria-label="add to favorites"
                    style={{ padding: 0 }}
                  >
                    <FavoriteBorderOutlined className="iconFav" />
                  </IconButton>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ marginRight: 5, fontWeight: "300" }}
                  >
                    Me gusta
                  </Typography>
                  <IconButton aria-label="share" style={{ padding: 0 }}>
                    <ChatBubbleOutline className="iconFav" />
                  </IconButton>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ marginRight: 5, fontWeight: "300" }}
                  >
                    Comentar
                  </Typography>
                </div>
                <div className="divDerec" style={{ width: "30%" }}>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ fontWeight: "300" }}
                  >
                    25 Me gusta
                  </Typography>
                </div>
              </CardActions>
              <CardContent
                style={{
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  display: "flex",
                  paddingTop: 0,
                  paddingBottom: 5
                }}
              >
                <div>
                  <img src={dutylogo} className="personNov" alt="logo" />
                </div>
                <div style={{ width: "100%" }}>
                  <TextField
                    id="standard-full-width"
                    style={{
                      marginTop: 8,
                      marginBottom: 8,
                      width: "100%",
                      fontSize: 14
                    }}
                    placeholder="Comentar"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </div>

        <div
          style={{
            flexDirection: "row",
            justifyContent: "center",
            display: "flex"
          }}
        >
          <Grid
            item
            xs={2}
            md={1}
            style={{ justifyContent: "center", display: "flex" }}
          >
            <img src={dutylogo} className="logonov" alt="logo" />
          </Grid>
          <Grid item xs={8} md={6} style={{ justifyContent: "flex-start" }}>
            <Card style={{ width: "100%", marginBottom: 15 }}>
              <CardMedia
                className={useStyles.media}
                image={dutyControl}
                title="Novedad"
              >
                <img src={dutyControl} style={{ width: "100%" }} />
              </CardMedia>
              <CardContent className="textCardNov">
                <Typography
                  className="titCard"
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  Formularios de encuestas personalizados
                </Typography>
                <Typography
                  className="subCardNov"
                  variant="body2"
                  color="textSecondary"
                  component="h4"
                >
                  Desplegar encuestas a todo su personal, red de franquiciados o
                  clientes
                </Typography>
                <Typography
                  variant="txtCardNov"
                  color="textSecondary"
                  component="p"
                >
                  Haga un seguimiento detallado de los aspectos claves de su
                  negocio, haciendo partícipes a todo su personal, red de
                  franquiciados, o clientes. Todo lo que considere necesario
                  ponderar, expresado en sencillos formularios de encuestas
                  personalizabas. Conoce mas en: www.dutygestion.com
                </Typography>
              </CardContent>
              <CardActions className="buttomCard">
                <div className="iconsButtomCard" style={{ width: "60%" }}>
                  <IconButton
                    aria-label="add to favorites"
                    style={{ padding: 0 }}
                  >
                    <FavoriteBorderOutlined className="iconFav" />
                  </IconButton>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ marginRight: 5, fontWeight: "300" }}
                  >
                    Me gusta
                  </Typography>
                  <IconButton aria-label="share" style={{ padding: 0 }}>
                    <ChatBubbleOutline className="iconFav" />
                  </IconButton>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ marginRight: 5, fontWeight: "300" }}
                  >
                    Comentar
                  </Typography>
                </div>
                <div className="divDerec" style={{ width: "30%" }}>
                  <Typography
                    variant="txtCardNov"
                    color="textSecondary"
                    component="p"
                    style={{ fontWeight: "300" }}
                  >
                    45 Me gusta
                  </Typography>
                </div>
              </CardActions>
              <CardContent
                style={{
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  display: "flex",
                  paddingTop: 0,
                  paddingBottom: 5
                }}
              >
                <div>
                  <img src={dutylogo} className="personNov" alt="logo" />
                </div>
                <div style={{ width: "100%" }}>
                  <TextField
                    id="standard-full-width"
                    style={{
                      marginTop: 8,
                      marginBottom: 8,
                      width: "100%",
                      fontSize: 14
                    }}
                    placeholder="Comentar"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </Grid>
    );
  };
  setModal = prop => {
    this.setState({ open1: prop });
  };
  setModals = prop => {
    this.setState({ modals: prop });
  };
  _newNovedad = () => {
    const { tit, sub, text, imagePreviewUrl } = this.state;
    if (!tit || !sub || !text || !imagePreviewUrl) {
      this.setState({ modalErrorStatus: true });
    } else {
      this.nov.obj.titulo = tit;
      this.nov.obj.subtitulo = sub;
      this.nov.obj.texto = text;
      this.nov.obj.imagen = imagePreviewUrl;
      this.nov.novedades.unshift(this.nov.obj);
      this.setState(
        { false: false, tit: "", sub: "", text: "", imagePreviewUrl: addphoto },
        () => {
          this.nov.obj = {};
          this.setModal(false);
          this.setState({ modals: !this.state.modals });
        }
      );
    }
  };
  _modalSuccess = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.modals}
        onClose={() => {
          this.setModals(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          item
          xs={12}
          className="cardModal"
          style={{
            width: window.innerWidth < 600 ? "70%" : "50%",
            height: "auto",
            alignItems: "center"
          }}
        >
          <CardContent>
            <img
              src={check}
              style={{ height: "50%", width: "100%", margin: "auto" }}
            />
          </CardContent>
          {/* <CardMedia
            style={{ height: "50%", width: "100%", margin: "auto" }}
            className="textCardNov"
            image={check}
            title="check"
          /> */}
          <CardContent className="textCardNov2">
            <Typography
              className="titCard"
              style={{ textAlign: "center" }}
              gutterBottom
              variant="h5"
              component="h2"
            >
              Novedad creada con éxito
            </Typography>
            <Typography
              variant="txtCardNov"
              color="textSecondary"
              component="p"
            >
              Has creado una nueva novedad que podrán ver todos los usuarios
            </Typography>
            <Button
              className="btn2"
              onClick={() => {
                this.setModals(false);
              }}
            >
              <Typography className="btnNewNov2">ACEPTAR</Typography>
            </Button>
          </CardContent>
        </Card>
        {/* </Fade> */}
      </Modal>
    );
  };
  _modal = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modal}
        open={this.state.open1}
        style={{ overflow: "scroll" }}
        onClose={() => {
          this.setModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          className="cardModal"
          style={{
            margin: "auto",
            marginTop: 30,
            width: window.innerWidth < 600 ? "70%" : "50%"
          }}
        >
          {this._pickImage()}
          <CardContent className="textCardModal">
            <div style={{ width: "100%" }}>
              <TextField
                id="standard-name"
                style={{
                  width: "100%",
                  marginTop: 0,
                  marginBottom: 0,
                  fontSize: 12
                }}
                className="txtTit"
                placeholder="Título"
                className={useStyles.textField}
                value={this.state.tit}
                inputProps={{
                  onChange: e => {
                    this.setState({ tit: e.target.value });
                  },
                  type: "text"
                }}
                margin="normal"
              />
            </div>
            <div style={{ width: "100%" }}>
              <TextField
                id="standard-name"
                placeholder="Subtitulo"
                style={{ width: "100%", marginTop: 0, marginBottom: 0 }}
                className={useStyles.textField}
                value={this.state.sub}
                inputProps={{
                  onChange: e => {
                    this.setState({ sub: e.target.value });
                  },
                  type: "text"
                }}
                margin="normal"
              />
            </div>
            <div style={{ width: "100%" }}>
              <TextField
                id="standard-name"
                placeholder="Escribir texto"
                style={{ width: "100%", marginTop: 0, marginBottom: 0 }}
                className={useStyles.textField}
                value={this.state.text}
                inputProps={{
                  onChange: e => {
                    this.setState({ text: e.target.value });
                  },
                  type: "text"
                }}
                margin="normal"
              />
            </div>
          </CardContent>
          <CardContent className="buttomNewNod">
            <div
              className="buttonsHed"
              style={{ width: "100%", display: "contents" }}
            >
              <Button
                style={{ width: "50%" }}
                className="btn1"
                onClick={() => {
                  this.setModal(false);
                }}
              >
                <Typography className="btnNewNov1">CANCELAR</Typography>
              </Button>
              <Button
                style={{ width: "50%" }}
                className="btn2"
                onClick={() => {
                  this._newNovedad();
                }}
              >
                <Typography className="btnNewNov2">ENVIAR</Typography>
              </Button>
            </div>
          </CardContent>
        </Card>
      </Modal>
    );
  };
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Header />
        <Toolbar />
        <div
          style={{
            paddingTop: window.innerWidth < 600 ? 70 : 10,
            paddingBottom: 20
          }}
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
            spacing={3}
            style={{ width: "100%" }}
          >
            <Grid
              item
              xs={6}
              sm={6}
              style={{
                width: "100%",
                paddingLeft: 20,
                justifyContent: "center"
              }}
            >
              <Typography className="novTit">Novedades</Typography>
            </Grid>
            <Grid item xs={6} sm={6} style={{ width: "100%" }}>
              <div className="divbtn3">
                <Button
                  className="btn3"
                  onClick={() => {
                    this.setState({ open1: !this.state.open1 });
                  }}
                >
                  <Add className="btn3icon" />
                  <Typography className="txtb3">CREAR NOVEDAD</Typography>
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
        {this._listaNov()}
        <div style={{ height: "100%" }}>
          {this._modal()}
          {this._modalSuccess()}
          {this.modalError()}
        </div>
        {/* <NovedadesCont /> */}
        {/* <ModalNew /> */}
        {/* <SimpleModal /> */}
        {/* </div> */}
      </React.Fragment>
    );
  }
}
function Header(props) {
  return (
    <ElevationScroll {...props}>
      <AppBar>
        <Toolbar
          style={{ backgroundColor: "#fff", paddingLeft: 0, paddingRight: 0 }}
        >
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sm={6}
              style={{ padding: 20, paddingBottom: 10 }}
            >
              <div>
                <Link to="/">
                  <img src={logo} className="App-logo" alt="logo" />
                </Link>
              </div>
            </Grid>
            <Grid
              container
              direction="row"
              justify="space-around"
              alignItems="center"
              xs={12}
              sm={6}
              style={{
                padding: 10,
                flexWrap: "nowrap",
                justifyContent: "center",
                marginBottom: 10
              }}
            >
              <div style={{ width: "40%", marginRight: 5 }}>
                <Link to="/">
                  <Button
                    className="btn1"
                    style={{
                      width: "100%",
                      padding: 0,
                      margin: 0,
                      backgroundColor: "#fff"
                    }}
                  >
                    <ArrowBack className="btn1icon" style={{}} />
                    <Typography className="txtb1" style={{ fontSize: 12 }}>
                      Seguir probando
                    </Typography>
                  </Button>
                </Link>
              </div>
              <div style={{ width: "40%", marginLeft: 5 }}>
                <Link to="/finish">
                  <Button
                    className="btn2"
                    style={{
                      width: "100%",
                      padding: 0,
                      margin: 0,
                      backgroundColor: "#F50027"
                    }}
                  >
                    <Typography className="txtb2">
                      Probar 14 días gratis{" "}
                    </Typography>
                  </Button>
                </Link>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
}
function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined
  });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  });
}
const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    }
  });
  return (
    <animated.div
      ref={ref}
      style={[
        style,
        { flexDirection: "row", flex: 1, justifyContent: "center" }
      ]}
      {...other}
    >
      {children}
    </animated.div>
  );
});
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func
};
const useStyles = makeStyles(theme => ({
  card: {
    width: "65%",
    marginBottom: 15,
    height: 300
  },
  media: {
    height: 300,
    paddingTop: "56.25%" // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  },
  modal: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
    justifyContent: "center",
    overflow: "scroll"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  textField: {
    width: "100%",
    marginTop: 0,
    fontSize: 15
  }
}));
